// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YqB0","controls":"styles_controls__3Fqid","charLimit":"styles_charLimit__3xyIo","input":"styles_input__1NTPu","send":"styles_send__3yVMa"};